/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseReleaseInfoParser = /* #__PURE__ */ parsers.object([
    ['commit', codecString],
]);
export class BaseReleaseInfo extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseReleaseInfoParser.decode(input).map(res => new BaseReleaseInfo(res));
    }
    static unsafeDecode(input) {
        return BaseReleaseInfo.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseReleaseInfoParser.encode(data);
    }
    static schema() {
        return BaseReleaseInfoParser.schema();
    }
}
